module.exports = __webpack_public_path__ + "static/media/microchip.d12a6d99.svg";